/* RESPONSIBLE TEAM: team-messenger */
import IntercomRoute from 'embercom/routes/base/intercom-route';

export default class MessengerSalesRoute extends IntercomRoute {
  queryParams = {
    style: {
      refreshModel: false,
      replace: true,
    },
  };

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-messenger',
    };
  }

  model() {
    let parentModel = this.modelFor('apps.app.settings.channels.messenger') as $TSFixMe;
    return {
      settings: parentModel.settings,
    };
  }
}
